import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { DataTable } from 'components';
import TableCard from 'components/Cards/TableCard';
import { tableFilters, testTableData, testTableLabels } from 'utils/constants';

export const TablesExamples: React.FC = () => {
  return (
    <VStack px={{ base: '16px', md: '32px' }}>
      <TableCard
        // eslint-disable-next-line no-console
        fetchDownload={() => console.log('download')}
        hasActions
        hasGlobalSearch
        customTitle={
          <Text
            alignSelf="center"
            color="text.100"
            fontSize="16px"
            fontWeight={400}
          >
            Entrada e Saída de <b>Manutenções</b>
          </Text>
        }
        subtitle="Comparativo sobre a relação entre entrada e saída de
        veículos em manutenções"
        overflowX="auto"
        w="100%"
        filters={tableFilters}
        labels={testTableLabels}
        data={testTableData(50)}
      />
      <TableCard
        customTitle={
          <Text
            alignSelf="center"
            color="text.100"
            fontSize="16px"
            fontWeight={400}
          >
            Entrada e Saída de <b>Manutenções</b>
          </Text>
        }
        subtitle="Comparativo sobre a relação entre entrada e saída de
        veículos em manutenções"
        overflowX="auto"
        w="100%"
        filters={tableFilters}
        labels={testTableLabels}
        data={testTableData(50)}
      />
      <TableCard
        // eslint-disable-next-line no-console
        fetchDownload={() => console.log('download')}
        hasGlobalSearch
        isPaginated={false}
        customTitle={
          <Text
            alignSelf="center"
            color="text.100"
            fontSize="16px"
            fontWeight={400}
          >
            Entrada e Saída de <b>Manutenções</b>
          </Text>
        }
        subtitle="Comparativo sobre a relação entre entrada e saída de
        veículos em manutenções"
        overflowX="auto"
        w="100%"
        filters={tableFilters}
        labels={testTableLabels}
        data={testTableData(15)}
      />
      <DataTable
        overflowX="auto"
        w="100%"
        filters={tableFilters}
        labels={testTableLabels}
        data={testTableData(60)}
      />
      <DataTable
        overflowX="auto"
        w="100%"
        labels={testTableLabels}
        data={testTableData(50)}
      />
    </VStack>
  );
};
